import { MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import {
  FlexCenter,
  FlexLeftCenter,
  FlexRowSB,
} from "../../../../constant/CustomeStyle";

const EditWarehouseType = (props) => {
  const warehouseLists = ["Beef", "Beef 2", "Beef 3"];

  const [warehouseOption, setWarehouseOption] = useState(warehouseLists[0]);
  const handleWarehouseType = (e) => {
    setWarehouseOption(e.target.value);
  };

  const tagLists = ["Tag", "Tag 2", "Tag 3"];

  const [tagOption, setTagOption] = useState(tagLists[0]);
  const handleTag = (e) => {
    setTagOption(e.target.value);
  };

  const {
    values: { Name },
    errors,
    touched,
    handleSubmit,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
  } = props;

  return (
    <div
      style={{
        marginTop: 20,
        width: 702,
      }}
    >
      <form>
        <FlexRowSB>
          <InputBoxN title={"Warehouse Name"} />
          <InputBoxDropdown
            title={"Warehouse Type"}
            handleChange={handleWarehouseType}
            itemLists={warehouseLists}
            currentValue={warehouseOption}
          />
        </FlexRowSB>

        <FlexRowSB style={{ marginTop: 15 }}>
          <InputBoxN title={"Meta Tag"} />
          <InputBoxDropdown
            title={"Inventory Meta Tag"}
            handleChange={handleTag}
            itemLists={tagLists}
            currentValue={tagOption}
          />
        </FlexRowSB>

        <div style={{ marginTop: 20 }}>
          <FlexCenter
            style={{
              width: 340,
              height: 48,
              borderRadius: 4,
              background: "#52BD9A",
              cursor: "pointer",
              fontSize: 18,
              fontFamily: "Poppins, sans-serif",
              fontWeight: "500",
              color: "#FFF",
            }}
          >
            Save
          </FlexCenter>
        </div>
      </form>
    </div>
  );
};

const InputBoxN = ({ title }) => (
  <div style={{ width: 340 }}>
    <FlexLeftCenter style={{ textAlign: "left", marginBottom: 5 }}>
      <div
        style={{
          fontSize: 16,
          fontFamily: "Poppins, sans-serif",
          color: "#1D1D1D",
        }}
      >
        {title}
      </div>
    </FlexLeftCenter>
    <TextField
      id="outlined-basic"
      variant="outlined"
      fullWidth
      InputProps={{
        style: {
          height: 48,
          background: "#FFF",
          border: "1px solid #CFCFCF",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
          borderRadius: 2,
        },
      }}
    />
  </div>
);

const InputBoxDropdown = ({ title, handleChange, itemLists, currentValue }) => (
  <div style={{ width: 340 }}>
    <div
      style={{
        textAlign: "left",
        marginBottom: 5,
        fontSize: 16,
        fontFamily: "Poppins, sans-serif",
        color: "#1D1D1D",
      }}
    >
      {title}
    </div>
    <TextField
      // id="outlined-select-currency"
      select
      value={currentValue}
      onChange={handleChange}
      fullWidth
      InputProps={{
        style: {
          height: 48,
          background: "#FFF",
          border: "1px solid #CFCFCF",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
          borderRadius: 2,
          textAlign: "left",
        },
      }}
    >
      {itemLists.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  </div>
);

export default EditWarehouseType;
